import createApiClient from "./api";
import { downloadBlob } from "../utils/downloadUtils";

const api = createApiClient();

export const fetchProjectSchedule = async (projectId) => {
  const response = await api.get(`/projects/${projectId}/schedule`);
  return response.data;
};

export const fetchProjectScheduleContent = async (projectId) => {
  const response = await api.get(`/projects/${projectId}/schedule/content`, {
    responseType: "text",
    timeout: 120000,
  });
  const fileName =
    response.headers["content-disposition"]?.match(/filename="(.+)"/)?.[1] ||
    "schedule.xer";

  return {
    content: response.data,
    fileName,
  };
};

export const parseProjectSchedule = async (projectId, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.post(
    `/projects/${projectId}/schedule/parse`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 180000,
    }
  );
  return response.data;
};

export const uploadProjectSchedule = async (
  projectId,
  file,
  { scheduleProjectName, stats } = {}
) => {
  const formData = new FormData();
  formData.append("file", file);
  if (scheduleProjectName) {
    formData.append("schedule_project_name", scheduleProjectName);
  }
  if (stats) {
    formData.append("stats", JSON.stringify(stats));
  }

  const response = await api.post(
    `/projects/${projectId}/schedule/upload`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 180000,
    }
  );
  return response.data;
};

export const deleteProjectSchedule = async (projectId) => {
  const response = await api.delete(`/projects/${projectId}/schedule`);
  return response.data;
};

export const downloadProjectSchedule = async (projectId, fileName) => {
  const response = await api.get(`/projects/${projectId}/schedule/content`, {
    responseType: "blob",
    timeout: 120000,
  });
  downloadBlob(response.data, fileName || "schedule.xer");
};
